"use strict";

import axios from "axios";
import api from "@/api/api";
import userService from "../../services/user.service";
import { CONSTANTS, getErrorMessage } from "../../global/index";

const {
  GETTING_INFO,
  GET_INFO_SUCCESS,
  SET_HISTORY_OPTION,
  SET_STATUS,
  ERROR_MSG,
  ERROR_STATUS,
} = CONSTANTS;

const ERROR_OBJ = {
  success: false,
  status: ERROR_STATUS,
  code: 500,
  message: ERROR_MSG,
  data: null,
};

const headers = () => ({ Authorization: userService.getToken() });

export default {
  namespaced: true,
  state: {
    loading: false,
    data: [],          // plantas
    accounts: [],
    reports: [],
    jobs: [],
    resumen: {},
    plant: null,       // detalle de una planta
    job: null,         // trabajo en curso
    historyOption: "Plantas",
    status: "",
  },

  getters: {
    loading: (state) => state.loading,
    data: (state) => state.data,
    accounts: (state) => state.accounts,
    reports: (state) => state.reports,
    jobs: (state) => state.jobs,
    resumen: (state) => state.resumen,
    plant: (state) => state.plant,
    job: (state) => state.job,
    getHistoryOption: (state) => state.historyOption,
    status: (state) => state.status,
    // plantas que necesitan que alguien las revise
    alertas: (state) =>
      state.data.filter(
        (p) => p.invertersDown > 0 || Number(p.changePct) <= -15
      ),
  },

  mutations: {
    [GETTING_INFO](state) {
      state.loading = true;
    },
    [GET_INFO_SUCCESS](state, change) {
      state.loading = false;
      state.data = change || [];
    },
    [SET_HISTORY_OPTION](state, change) {
      state.historyOption = change;
    },
    [SET_STATUS](state, value) {
      state.status = value;
    },
    SET_ACCOUNTS(state, value) {
      state.loading = false;
      state.accounts = value || [];
    },
    SET_REPORTS(state, value) {
      state.loading = false;
      state.reports = value || [];
    },
    SET_JOBS(state, value) {
      state.jobs = value || [];
    },
    SET_RESUMEN(state, value) {
      state.resumen = value || {};
    },
    SET_PLANT(state, value) {
      state.loading = false;
      state.plant = value;
    },
    SET_JOB(state, value) {
      state.job = value;
    },
  },

  actions: {
    setHistoryOptionMon({ commit }, payload) {
      commit(SET_HISTORY_OPTION, payload);
    },

    // ── lecturas ───────────────────────────────────────────────────────────
    async getPlantsMon({ commit }) {
      commit(GETTING_INFO);
      try {
        const response = await api.getAllInfo("monitoring/plants", headers());
        commit(GET_INFO_SUCCESS, response.data.data);
        return response.data;
      } catch (error) {
        commit(GET_INFO_SUCCESS, []);
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },

    async getPlantMon({ commit }, id) {
      commit(GETTING_INFO);
      try {
        const response = await api.getInfoById(
          { option: "monitoring/plants", id },
          headers()
        );
        commit("SET_PLANT", response.data.data);
        return response.data.data;
      } catch (error) {
        commit("SET_PLANT", null);
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },

    async getAccountsMon({ commit }) {
      commit(GETTING_INFO);
      try {
        const response = await api.getAllInfo("monitoring/accounts", headers());
        commit("SET_ACCOUNTS", response.data.data);
        return response.data;
      } catch (error) {
        commit("SET_ACCOUNTS", []);
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },

    async getResumenMon({ commit }) {
      try {
        const response = await api.getAllInfo("monitoring/resumen", headers());
        commit("SET_RESUMEN", response.data.data);
        return response.data.data;
      } catch (error) {
        return ERROR_OBJ;
      }
    },

    async getReportsMon({ commit }) {
      commit(GETTING_INFO);
      try {
        const response = await api.getAllInfo("monitoring/reports", headers());
        commit("SET_REPORTS", response.data.data);
        return response.data;
      } catch (error) {
        commit("SET_REPORTS", []);
        return ERROR_OBJ;
      }
    },

    async getJobsMon({ commit }) {
      try {
        const response = await api.getAllInfo("monitoring/jobs", headers());
        commit("SET_JOBS", response.data.data);
        return response.data.data;
      } catch (error) {
        return [];
      }
    },

    async getJobMon({ commit }, id) {
      try {
        const response = await api.getInfoById(
          { option: "monitoring/jobs", id },
          headers()
        );
        commit("SET_JOB", response.data.data);
        return response.data.data;
      } catch (error) {
        return null;
      }
    },

    // ── escrituras ─────────────────────────────────────────────────────────
    async addAccountMon(_, item) {
      try {
        const response = await api.addItem(
          { option: "monitoring/accounts", item },
          headers()
        );
        return response.data;
      } catch (error) {
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },

    async editAccountMon(_, item) {
      try {
        const response = await api.editItem(
          { option: "monitoring/accounts", item },
          headers()
        );
        return response.data;
      } catch (error) {
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },

    async deleteAccountMon(_, id) {
      try {
        const response = await api.deleteItem(
          { option: "monitoring/accounts", id },
          headers()
        );
        return response.data;
      } catch (error) {
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },

    async testAccountMon(_, item) {
      try {
        const response = await axios.post("/monitoring/accounts/test", item, {
          headers: headers(),
        });
        return response.data;
      } catch (error) {
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return error.response.data;
      }
    },

    async editPlantMon(_, item) {
      try {
        const response = await api.editItem(
          { option: "monitoring/plants", item },
          headers()
        );
        return response.data;
      } catch (error) {
        if (!error?.response?.data?.message) return ERROR_OBJ;
        return getErrorMessage(error.response.data.message);
      }
    },

    // ── procesos ───────────────────────────────────────────────────────────
    async syncMon({ commit }) {
      try {
        const response = await axios.post("/monitoring/sync", {}, { headers: headers() });
        commit("SET_JOB", response.data.data);
        return response.data;
      } catch (error) {
        if (!error?.response?.data) return ERROR_OBJ;
        return error.response.data;
      }
    },

    async generateReportsMon({ commit }) {
      try {
        const response = await axios.post(
          "/monitoring/reports/generate",
          {},
          { headers: headers() }
        );
        commit("SET_JOB", response.data.data);
        return response.data;
      } catch (error) {
        if (!error?.response?.data) return ERROR_OBJ;
        return error.response.data;
      }
    },

    async generatePdfsMon({ commit }) {
      try {
        const response = await axios.post(
          "/monitoring/reports/generate-pdf",
          {},
          { headers: headers() }
        );
        commit("SET_JOB", response.data.data);
        return response.data;
      } catch (error) {
        if (!error?.response?.data) return ERROR_OBJ;
        return error.response.data;
      }
    },

    /** Regenera el PDF de una sola planta, cuando corriges un dato suelto. */
    async regeneratePdfMon(_, plantId) {
      try {
        const response = await axios.post(
          `/monitoring/plants/${plantId}/pdf`,
          {},
          { headers: headers() }
        );
        return response.data;
      } catch (error) {
        if (!error?.response?.data) return ERROR_OBJ;
        return error.response.data;
      }
    },

    async cancelJobMon(_, id) {
      try {
        const response = await api.deleteItem(
          { option: "monitoring/jobs", id },
          headers()
        );
        return response.data;
      } catch (error) {
        return ERROR_OBJ;
      }
    },

    /** Descarga un Excel respetando el token de sesion. */
    async downloadReportMon(_, report) {
      try {
        const response = await axios.get(
          `/monitoring/reports/${report.id}/download`,
          { headers: headers(), responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const enlace = document.createElement("a");
        enlace.href = url;
        enlace.setAttribute("download", report.fileName);
        document.body.appendChild(enlace);
        enlace.click();
        enlace.remove();
        window.URL.revokeObjectURL(url);
        return { success: true };
      } catch (error) {
        return { success: false, message: "No se pudo descargar el archivo" };
      }
    },
  },
};
